import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, vModelText as _vModelText, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-694df5b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-wrap w-1200 h-700" }
const _hoisted_2 = { class: "main-title col-b-title" }
const _hoisted_3 = { class: "sub-title f-s-24 col-b-title m-t-24" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "javascript: void(0)" }, "了解更多", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "banner-index-wrap absolute b-20 flex-row flex-no-wrap pointer" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "device-wrap w-1200 flex-row flex-no-wrap justify-between align-center" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "device-title f-s-14 m-t-8 col-b-title text-center" }
const _hoisted_12 = { class: "f-s-12 m-t-8 col-b-title opacity-7 text-center" }
const _hoisted_13 = {
  key: 0,
  class: "video-wrap flex-row align-center justify-center"
}
const _hoisted_14 = { class: "video-content relative w-1200" }
const _hoisted_15 = ["src"]
const _hoisted_16 = ["src"]
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "plat-wrap flex-row align-center justify-center" }
const _hoisted_19 = { class: "plat-content w-1200" }
const _hoisted_20 = { class: "plat-title-wrap" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "f-s-44 col-b-title text-center" }, "融合平台", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "f-s-24 col-b-title m-t-10 text-center" }, "一个入口，融合多个管理、教学应用，支持公有或私有云部署", -1))
const _hoisted_23 = { class: "plat-info-wrap flex-row flex-no-wrap align-center justify-between m-t-40" }
const _hoisted_24 = { class: "plat-info-type w-450" }
const _hoisted_25 = ["onMouseenter"]
const _hoisted_26 = ["src"]
const _hoisted_27 = { class: "m-l-20" }
const _hoisted_28 = { class: "plat-main-name f-s-16 col-b-title" }
const _hoisted_29 = { class: "f-s-16 col-b-title m-t-4 opacity-7" }
const _hoisted_30 = { class: "plat-img-wrap" }
const _hoisted_31 = ["src"]
const _hoisted_32 = { class: "classroom-content w-1200 relative" }
const _hoisted_33 = { class: "f-s-32 col-b-white opacity-7" }
const _hoisted_34 = { class: "f-s-32 col-b-white" }
const _hoisted_35 = { class: "classroom-flow f-s-14 col-b-white m-t-30 opacity-7 f-w-300" }
const _hoisted_36 = { class: "nav-wrap absolute b-30 flex-row flex-no-wrap align-center justify-between" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "logo-wrap" }
const _hoisted_39 = { class: "logo-content w-1200 border-box p-t-80 p-b-80" }
const _hoisted_40 = /*#__PURE__*/_createStaticVNode("<div class=\"main-title f-s-44 col-b-title f-w-600 text-center\" data-v-694df5b2>东信同邦，常态化智慧教室引领者</div><div class=\"f-s-24 col-b-title opacity-7 m-t-20 text-center\" data-v-694df5b2>截至目前，东信同邦已服务</div><div class=\"w-1200 flex-row flex-no-wrap justify-between align-center\" style=\"margin:60px auto;\" data-v-694df5b2><div class=\"text-center p-t-30 p-b-30 p-l-100 p-r-90\" data-v-694df5b2><div class=\"col-b-blue\" style=\"font-size:54px;\" data-v-694df5b2>5000+</div><div class=\"f-s-20 col-b-title m-t-15\" data-v-694df5b2>高教、普教院校</div></div><div class=\"text-center p-t-30 p-b-30 p-l-100 p-r-90\" data-v-694df5b2><div class=\"col-b-blue\" style=\"font-size:54px;\" data-v-694df5b2>20000+</div><div class=\"f-s-20 col-b-title m-t-15\" data-v-694df5b2>高教、普教院校教室</div></div><div class=\"text-center p-t-30 p-b-30 p-l-100 p-r-90\" data-v-694df5b2><div class=\"col-b-blue\" style=\"font-size:54px;\" data-v-694df5b2>5000000+</div><div class=\"f-s-20 col-b-title m-t-15\" data-v-694df5b2>高教、普教院校师生</div></div></div>", 3)
const _hoisted_43 = { class: "logo-banner-wrap m-t-30 relative" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "f-s-24 col-b-title opacity-7 m-t-60 text-center" }, "全国各地院校，正携手东信同邦实现智慧教室建设成果落地", -1))
const _hoisted_45 = {
  key: 1,
  class: "news-wrap"
}
const _hoisted_46 = { class: "news-content border-box w-1200 h-100p p-t-80 p-b-80" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "new-main-title f-s-44 col-b-title" }, "企业动态", -1))
const _hoisted_48 = { class: "new-info-wrap m-t-60 flex-row flex-no-wrap justify-between" }
const _hoisted_49 = { class: "new-left" }
const _hoisted_50 = { class: "first-name wbba h-40 opacity-7 f-s-28 col-b-title pointer" }
const _hoisted_51 = { class: "f-s-14 opacity-3 m-t-10" }
const _hoisted_52 = { class: "new-flow f-s-14 opacity-7 m-t-10 f-w-300" }
const _hoisted_53 = ["onClick"]
const _hoisted_54 = { class: "new-right" }
const _hoisted_55 = ["src"]
const _hoisted_56 = { class: "connect-wrap border-box p-t-80 p-b-80" }
const _hoisted_57 = { class: "form-content w-1200 block-center" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "new-main-title f-s-44 col-b-title" }, "进一步获取产品详情及报价", -1))
const _hoisted_59 = { class: "form-wrap m-t-40 flex-row flex-no-wrap" }
const _hoisted_60 = {
  key: 0,
  class: "success-message col-b-red l-h-54 m-l-20"
}

import { onMounted, onUnmounted, ref } from 'vue';
import LogoBanner from '@/components/LogoBanner.vue';
import { useRouter } from 'vue-router';
import { getBanner, getNews, getRichText, getSchoolIcon, postConnect } from '@/api/webIndex.js';
import { ROUTE_PLAN, ROUTE_PRODUCTION } from '@/utils/route';
import {
	PRODUCTION_CATEGORY_3D,
	PRODUCTION_CATEGORY_GROUPS,
	PRODUCTION_CATEGORY_LIST,
	PRODUCTION_CATEGORY_THREE_LESSON, PRODUCTION_CATEGORY_WIFI_DEV,
	PRODUCTION_CATEGORY_PLATFORM
} from '@/utils/production';
import {
	PLAN_CATEGORY_LIST,
	PLAN_CATEGORY_ROOM_BUILD, PLAN_CATEGORY_ROOM_SOLUTION, PLAN_CATEGORY_ROOM_SYSTEM,
	PLAN_CATEGORY_ROOM_UPGRADE,
	PLAN_CATEGORY_THREE_LESSON_BUILD
} from '@/utils/plan';
import { useStore } from 'vuex';
import { FOOTER_NAV_LIST } from '@/utils/company';

interface deviceItem {
	id: number,
	src: string,
	title: string,
	flow: string,
	key: string,
}

interface platItem {
	id: number,
	src: string,
	name: string,
	flow: string,
	logo: string
}

interface classroomItem {
	id: number,
	src: string,
	name: string,
	flow: string,
	title: string,
	title2: string,
	link: string,
	titleWidth: number,
	key: string,
}

interface bannerItem {
	id: number,
	image: string,
	title: string,
	desc: string,
	link: string
}

interface newItem {
	id: number,
	src: string,
	name: string,
	flow: string,
	time: string
}

//静态数据

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const
	deviceList: deviceItem[] = [
		{
			id: 0,
			src: require('@/assets/device_group.png'),
			title: '小组讨论终端',
			flow: '免装 APP，小组讨论更自由',
			key: PRODUCTION_CATEGORY_GROUPS
		},
		{
			id: 1,
			src: require('@/assets/device_three.png'),
			title: '“三个课堂”互动录播终端',
			flow: '支持H.323和SIP标准通讯协议的一体',
			key: PRODUCTION_CATEGORY_THREE_LESSON
		},
		{
			id: 2,
			src: require('@/assets/device_wlan.png'),
			title: '无线便携互动终端',
			flow: '0布线 5分钟完成搭建',
			key: PRODUCTION_CATEGORY_WIFI_DEV
		},
		{
			id: 3,
			src: require('@/assets/device_3D.png'),
			title: '3D传感器',
			flow: '让自动录播媲美人工拍摄的黑科技',
			key: PRODUCTION_CATEGORY_3D
		}
	],
	platList: platItem[] = [
		{
			id: 0,
			src: require('@/assets/teach_plat.png'),
			name: 'AI辅助督导评课',
			flow: '专注于教师发展和教师能力提升，全面提高教',
			logo: require('@/assets/teach_logo.png')
		},
		{
			id: 1,
			src: require('@/assets/device_plat.png'),
			name: '设备集中管控',
			flow: '远程管控全校智慧教室，智能运维更轻松',
			logo: require('@/assets/device_logo.png')
		},
		{
			id: 2,
			src: require('@/assets/resource_plat.png'),
			name: '在线教学资源管理',
			flow: '创建校本资源库，赋能在线教学应用',
			logo: require('@/assets/resource_logo.png')
		},
		{
			id: 3,
			src: require('@/assets/datestatic_plat.png'),
			name: '大数据分析',
			flow: 'AI+大数据，助力学校教学质量评估和提升',
			logo: require('@/assets/datestatic_logo.png')
		},
		{
			id: 4,
			src: require('@/assets/media_plat.png'),
			name: '媒体发布',
			flow: '打造校园融媒体中心',
			logo: require('@/assets/media_logo.png')
		}
	],
	classroomList: classroomItem[] = [
		{
			id: 0,
			src: require('@/assets/classroom_wisdom.jpg'),
			name: '智慧教室建设方案',
			flow: `·智慧教学：电子白板、创新课堂、分组教学、自动录播导播、师生交互等\n` +
				`·智慧管理：智能教室中控、物联管控、资管管理、教学督导、考勤统计等\n` +
				`·智慧评价：AI学情分析、教学分析、行为分析、在线听评课、优课评选等`,
			title: '1台核心设备+1块屏幕=1间智慧教室',
			title2: '集成50+功能,助力1000+院校智慧校园建设',
			link: '',
			titleWidth: 520,
			key: PLAN_CATEGORY_ROOM_UPGRADE
		},
		{
			id: 3,
			src: require('@/assets/mixed_lesson_teach.png'),
			name: '混合式课堂解决方案',
			flow: `以混合式教学终端为核心，快速将普通教室升级成支持混合式线上线下授课、常态化\n` +
				`录播、听评课教研、远程巡课督导、网络教研、三个课堂、无线麦扩声等多种教学应\n` +
				`用的智慧型教室，为学校带来“教、学、管、研、评”全方位教学体验提升。`,
			title: '1台设备+4根线缆',
			title2: '5分钟让K12普通教室升级为智慧教室',
			link: '',
			titleWidth: 525,
			key: PLAN_CATEGORY_ROOM_SOLUTION
		},
		{
			id: 4,
			src: require('@/assets/back_in_time_system.png'),
			name: '可以时光倒流的智慧实训系统',
			flow: `不挑实训场景，无论教学、练习、考试、比赛、管理，应用智慧实训方案，完美解决\n实训围观、视角单一、直播不能回退、过程无法记录、成果检验低效、实训场景受\n限、实训教研局限等问题，快速升级实训体验。`,
			title: '可以时光倒流的智慧实训系统',
			title2: '内核是智慧实训推车，也是可移动的时光机',
			link: '',
			titleWidth: 610,
			key: PLAN_CATEGORY_ROOM_SYSTEM
		},
		{
			id: 1,
			src: require('@/assets/classroom_three.jpg'),
			name: '“三个课堂”建设方案',
			flow: `“三个课堂”解决方案，可实现1个校区上课，多个校区实时互动的1+N多点\n模式，实现专递课堂、听评课教研、优质教学资源的共享共建。支持多校协\n作教学，使更多学生共享名师课堂、名校网络课堂，落实常态化应用。`,
			title: '功能强大，性价比高，快速完成区',
			title2: '域级教育战略布局',
			link: '',
			titleWidth: 520,
			key: PLAN_CATEGORY_THREE_LESSON_BUILD
		},
		{
			id: 2,
			src: require('@/assets/old_classroom_tradition@2x.png'),
			name: '传统教室升级方案',
			flow: '传统教室升级改造方案，通过1台“智慧教室终端”快速实现课堂应用升级，提供智\n能化中控、圈点批注、电子白板、对比教学、信息发布等功能，打造集智慧教\n学、集中管理于一体的信息化教学系统。',
			title: '1台核心设备=常态化智慧教室',
			title2: '',
			link: '',
			titleWidth: 520,
			key: PLAN_CATEGORY_ROOM_BUILD
		}
	],
	router = useRouter(),
	store = useStore(),
	playSrc: string = require('@/assets/play.png'),
	pauseSrc: string = require('@/assets/pause.png'),
	defaultBannerList: bannerItem[] = [
		{
			id: 0,
			image: require('@/assets/banner_black.jpg'),
			title: '智慧教室终端 ·小黑Pro',
			desc: '“四一设计”（1台核心设备，1块屏幕，1个工具栏，1分钟学会），开创智慧教室常态化应用新篇章',
			link: 'https://www.baidu.com'
		},
		{
			id: 0,
			image: require('@/assets/banner_black.jpg'),
			title: '智慧教室终端 ·小白Pro',
			desc: '开创智慧教室常态化应用新篇章，“四一设计”（1台核心设备，1块屏幕，1个工具栏，1分钟学会）',
			link: 'https://www.hao123.com'
		}
	];

// 动态数据
const
	bannerList = ref<bannerItem[]>([]),
	bannerIndex = ref<number>(0),
	bannerInter = ref<number>(0),
	platIndex = ref<number>(0),
	classroomIndex = ref<number>(0),
	videoSrc = ref<string>(''),
	videoCoverSrc = ref<string>(''),
	videoCoverShowFlag = ref<boolean>(true),
	newList = ref<newItem[]>([]),
	videoControl = ref<string>(playSrc),
	videoPlay = ref<string>(''),
	schoolIconTotal = ref<number>(0),
	name = ref<string>(''),
	phone = ref<string>(''),
	successFlag = ref<boolean>(false),
	successMessage = ref<string>('');

// 方法

const routeJumpWithTitle = (url: string) => {

	const list = FOOTER_NAV_LIST;
	let moduleName = '', moduleType = '', subTitle = '';
	list.forEach(item => {
		if (url.includes(item.route)) {
			moduleName = item.route;
			const childrenList = item.children;
			childrenList.forEach(child => {
				if (child.key && url.includes(child.key)) {
					moduleType = child.key;
					subTitle = child.name;
				}
			});
		}
	});
	console.log(moduleName, moduleType, subTitle, store);
	if (moduleName && moduleType) {
		store.dispatch('setActiveTitle', subTitle);
		router.push({ path: `/${moduleName}/${moduleType}` });
	} else if (moduleName) {
		router.push({ name: moduleName });
	} else if (!moduleName) {
		window.open(url, '_blank');
	}
};

const
	onChangeIndex = (index: number) => {
		bannerIndex.value = index;
	},
	onClearInter = () => {
		clearInterval(bannerInter.value);
	},
	onRestartInter = () => {
		setInter();
	},
	setInter = () => {
		bannerInter.value = setInterval(() => {
			onChangeIndex(bannerIndex.value >= (bannerList.value.length - 1) ? bannerIndex.value = 0 : bannerIndex.value += 1);
		}, 5000);
	},
	onToBannerUrl = (item: bannerItem) => {
		routeJumpWithTitle(item.link);
	},
	onToNews = () => {
		router.push({
			name: 'news'
		});
	},
	onChangeVideoStatus = () => {
		videoCoverShowFlag.value = false;
		if (videoControl.value === playSrc) {
			videoPlay.value.play();
			videoControl.value = pauseSrc;
		} else {
			videoPlay.value.pause();
			videoControl.value = playSrc;
		}
	},
	onGetBanner = async () => {
		try {
			let res = await getBanner();
			if (res.message === 'ok' && res.data?.length) {
				bannerList.value = res.data;
			} else {
				bannerList.value = defaultBannerList;
			}
		} catch (e) {
			bannerList.value = defaultBannerList;
			console.log(e);
		}
	},
	onGetNews = async () => {
		try {
			let res = await getNews({ per_page: 3 });
			if (res.message === 'ok') {
				newList.value = res.data?.data;
			}
		} catch (e) {
			console.log(e);
		}
	},
	onGetVideo = async () => {
		try {
			let res = await getRichText();
			if (res.message === 'ok') {
				videoSrc.value = res.data.video;
				videoCoverSrc.value = res.data.video_cover;
			}
		} catch (e) {
			console.log(e);
		}
	},
	onToNewDetail = (id: number) => {
		router.push({
			name: 'newDetail',
			query: {
				id
			}
		});
	},
	onGetSchoolIcon = async () => {
		try {
			let res = await getSchoolIcon();
			if (res.message === 'ok') {
				schoolIconTotal.value = res.data.total;
			} else {
				console.log(res.data.total);
			}
		} catch (e) {
			console.log(e);
		}
	},
	onToDeviceDetail = (index: string) => {
		let routeName: any = '';

		const find = PRODUCTION_CATEGORY_LIST.find(item => item.key === index);
		router.push({
			path: `/${ROUTE_PRODUCTION}/${find?.key}`
		});
		routeName = find?.name;

		if (routeName) {
			store.dispatch('setActiveTitle', routeName);
		}
	},
	onToClassroomDetail = () => {

		const key = classroomList[classroomIndex.value].key;

		const find = PLAN_CATEGORY_LIST.find(item => item.key === key);
		router.push({
			path: `/${ROUTE_PLAN}/${find?.key}`
		});
		store.dispatch('setActiveTitle', find?.name);
	},
	onToLogo = () => {
		router.push({
			path: `project`
		});
	},
	onPostConnect = async () => {
		try {
			let res = await postConnect({
				name: name.value,
				phone: phone.value
			});
			if (res.message === 'ok') {
				name.value = '';
				phone.value = '';
				successFlag.value = true;
				successMessage.value = '√ 提交成功';
				setTimeout(() => {
					successFlag.value = false;
				}, 3000);
			} else {
				successFlag.value = true;
				successMessage.value = res.message;
				setTimeout(() => {
					successFlag.value = false;
				}, 1000);
			}
		} catch (e) {
			console.log(e);
		}
	};

onMounted(() => {
	onChangeIndex(0);
	setInter();
	onGetBanner();
	onGetNews();
	onGetVideo();
	onGetSchoolIcon();
});

onUnmounted(() => {
	onClearInter();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", {
      class: "banner-wrap w-100p relative h-700",
      onMouseenter: onClearInter,
      onMouseleave: onRestartInter,
      style: _normalizeStyle({backgroundImage:bannerList.value[bannerIndex.value] && `url(${bannerList.value[bannerIndex.value].image})`})
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(bannerList.value[bannerIndex.value] && bannerList.value[bannerIndex.value].title), 1),
        _createElementVNode("div", _hoisted_3, _toDisplayString(bannerList.value[bannerIndex.value] && bannerList.value[bannerIndex.value].desc), 1),
        _createElementVNode("div", {
          class: "more-btn w-120 h-40 brs4 m-t-40 col-b-blue pointer",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (onToBannerUrl(bannerList.value[bannerIndex.value])))
        }, _hoisted_5)
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bannerList.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["banner-index w-10 h-10 brs-percent-50 m-r-8", {'selected':bannerIndex.value === index}]),
            key: item.id,
            onClick: ($event: any) => (onChangeIndex(index))
          }, null, 10, _hoisted_7))
        }), 128))
      ])
    ], 36),
    _createElementVNode("section", _hoisted_8, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(deviceList, (item) => {
        return _createElementVNode("div", {
          class: "device-list h-200 p-20 brs20 text-center pointer",
          onClick: ($event: any) => (onToDeviceDetail(item.key)),
          key: item.id
        }, [
          _createElementVNode("img", {
            src: item.src,
            alt: "",
            class: "w-200 h-110"
          }, null, 8, _hoisted_10),
          _createElementVNode("div", _hoisted_11, _toDisplayString(item.title), 1),
          _createElementVNode("div", _hoisted_12, _toDisplayString(item.flow), 1)
        ], 8, _hoisted_9)
      }), 64))
    ]),
    (videoSrc.value)
      ? (_openBlock(), _createElementBlock("section", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("video", {
              loop: "",
              ref_key: "videoPlay",
              ref: videoPlay,
              src: videoSrc.value,
              class: "w-1200"
            }, null, 8, _hoisted_15),
            _createElementVNode("img", {
              src: videoControl.value,
              onClick: onChangeVideoStatus,
              class: _normalizeClass(["videoControl absolute w-40 h-40 pointer", {["no-opacity"]: videoCoverShowFlag.value}]),
              alt: ""
            }, null, 10, _hoisted_16),
            _withDirectives(_createElementVNode("img", {
              src: videoCoverSrc.value,
              alt: "",
              class: "video-cover"
            }, null, 8, _hoisted_17), [
              [_vShow, videoCoverShowFlag.value]
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("section", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _hoisted_22,
          _createElementVNode("div", {
            class: "f-s-14 col-b-blue m-t-10 pointer text-center",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (onToDeviceDetail(_unref(PRODUCTION_CATEGORY_PLATFORM))))
          }, "了解更多 >")
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(platList, (item, index) => {
              return _createElementVNode("div", {
                class: _normalizeClass(["plat-info-list border-box w-450 h-80 brs10 flex-row flex-no-wrap align-center justify-start p-20 pointer m-t-10", {'selected':platIndex.value===index}]),
                key: item.id,
                onMouseenter: ($event: any) => (platIndex.value = index)
              }, [
                _createElementVNode("img", {
                  src: item.logo,
                  class: "w-40 h-40",
                  alt: ""
                }, null, 8, _hoisted_26),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, _toDisplayString(item.name), 1),
                  _createElementVNode("div", _hoisted_29, _toDisplayString(item.flow), 1)
                ])
              ], 42, _hoisted_25)
            }), 64))
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("img", {
              src: platList[platIndex.value].src,
              alt: ""
            }, null, 8, _hoisted_31)
          ])
        ])
      ])
    ]),
    _createElementVNode("section", {
      class: "classroom-wrap",
      style: _normalizeStyle({backgroundImage: `url(${classroomList[classroomIndex.value].src})`})
    }, [
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("div", {
          class: "classroom-info h-100p border-box p-t-70 relative",
          style: _normalizeStyle({width:classroomList[classroomIndex.value].titleWidth+'px'})
        }, [
          _createElementVNode("div", _hoisted_33, _toDisplayString(classroomList[classroomIndex.value].name), 1),
          _createElementVNode("div", {
            class: _normalizeClass(["f-s-32 m-t-30 col-b-white", {'col-b-blue':classroomIndex.value === 0}])
          }, _toDisplayString(classroomList[classroomIndex.value].title), 3),
          _createElementVNode("div", _hoisted_34, _toDisplayString(classroomList[classroomIndex.value].title2), 1),
          _createElementVNode("pre", _hoisted_35, _toDisplayString(classroomList[classroomIndex.value].flow) + "\r\n        ", 1),
          _createElementVNode("div", {
            class: "f-s-14 col-b-white m-t-40 pointer",
            onClick: onToClassroomDetail
          }, "了解详情 >"),
          _createElementVNode("div", _hoisted_36, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(classroomList, (item, index) => {
              return _createElementVNode("div", {
                class: _normalizeClass(["nav-list f-s-14 col-b-white pointer opacity-7", {'selected':classroomIndex.value===index}]),
                key: item.id,
                onClick: ($event: any) => (classroomIndex.value = index)
              }, _toDisplayString(item.name), 11, _hoisted_37)
            }), 64))
          ])
        ], 4)
      ])
    ], 4),
    _createElementVNode("section", _hoisted_38, [
      _createElementVNode("div", _hoisted_39, [
        _hoisted_40,
        _createElementVNode("div", _hoisted_43, [
          _createVNode(LogoBanner, {
            size: schoolIconTotal.value/5
          }, null, 8, ["size"]),
          _createVNode(LogoBanner, {
            page: 2,
            size: schoolIconTotal.value/5,
            "is-shadow": false,
            speed: .7
          }, null, 8, ["size"]),
          _createVNode(LogoBanner, {
            page: 3,
            size: schoolIconTotal.value/5,
            speed: .9
          }, null, 8, ["size"]),
          _createVNode(LogoBanner, {
            page: 4,
            size: schoolIconTotal.value/5,
            "is-shadow": false,
            speed: .6
          }, null, 8, ["size"]),
          _createVNode(LogoBanner, {
            page: 5,
            size: schoolIconTotal.value/5,
            speed: .8
          }, null, 8, ["size"])
        ]),
        _hoisted_44,
        _createElementVNode("div", {
          class: "f-s-14 col-b-blue pointer m-t-24 text-center",
          onClick: onToLogo
        }, "了解更多 >")
      ])
    ]),
    (newList.value.length)
      ? (_openBlock(), _createElementBlock("section", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, [
            _hoisted_47,
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("div", {
                  class: "first-new",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (onToNewDetail(newList.value[0].id)))
                }, [
                  _createElementVNode("div", _hoisted_50, _toDisplayString(newList.value[0] && newList.value[0].title), 1),
                  _createElementVNode("div", _hoisted_51, _toDisplayString(newList.value[0] && newList.value[0].created_at), 1),
                  _createElementVNode("div", _hoisted_52, _toDisplayString(newList.value[0] && newList.value[0].desc), 1)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newList.value.slice(1,3), (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "new-list h-40 wbba f-s-28 opacity-7 m-t-40 pointer col-b-title",
                    onClick: ($event: any) => (onToNewDetail(item.id)),
                    key: item.id
                  }, _toDisplayString(item.title), 9, _hoisted_53))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("img", {
                  class: "brs20",
                  src: newList.value[0] && newList.value[0].cover,
                  alt: ""
                }, null, 8, _hoisted_55)
              ])
            ]),
            _createElementVNode("div", {
              class: "f-s-14 col-b-blue pointer",
              onClick: onToNews
            }, "了解更多资讯 >")
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("section", _hoisted_56, [
      _createElementVNode("div", _hoisted_57, [
        _hoisted_58,
        _createElementVNode("div", _hoisted_59, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "w-180 h-50 brs8 m-r-30 f-s-16",
            placeholder: "请输入姓名",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((name).value = $event))
          }, null, 512), [
            [_vModelText, name.value]
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "w-180 h-50 brs8 m-r-30 f-s-16",
            placeholder: "请输入电话号码",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((phone).value = $event))
          }, null, 512), [
            [_vModelText, phone.value]
          ]),
          _createElementVNode("div", {
            class: "sub-btn w-160 h-54 brs8 col-b-white text-center pointer",
            onClick: onPostConnect
          }, "提交"),
          (successFlag.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_60, _toDisplayString(successMessage.value), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 64))
}
}

})